import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';
@Component({
    selector: 'icon-wether-cloud',
    template: `
        <ng-template #template>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="20" height="20" [ngClass]="class">
          <path d="M29 8.53125C23.785156 8.53125 19.371094 11.652344 17.25 16.0625C16.121094 15.285156 14.8125 14.71875 13.34375 14.71875C9.617188 14.71875 6.644531 17.667969 6.4375 21.34375C2.710938 22.6875 0 26.164063 0 30.34375C0 35.671875 4.328125 40 9.65625 40L41.09375 40C46 40 50 36 50 31.09375C50 26.542969 46.507813 22.925781 42.09375 22.40625C42.109375 22.164063 42.15625 21.9375 42.15625 21.6875C42.15625 14.4375 36.25 8.53125 29 8.53125 Z M 29 10.53125C35.171875 10.53125 40.15625 15.519531 40.15625 21.6875C40.15625 22.144531 40.121094 22.59375 40.0625 23.0625L39.90625 24.1875L41.09375 24.1875C44.917969 24.1875 48 27.269531 48 31.09375C48 34.917969 44.917969 38 41.09375 38L9.65625 38C5.40625 38 2 34.589844 2 30.34375C2 26.808594 4.382813 23.832031 7.625 22.9375L8.375 22.75L8.34375 21.9375C8.339844 21.796875 8.34375 21.726563 8.34375 21.71875C8.34375 18.941406 10.566406 16.71875 13.34375 16.71875C14.734375 16.71875 16 17.277344 16.90625 18.1875L18 19.3125L18.53125 17.84375C20.105469 13.59375 24.191406 10.53125 29 10.53125Z" fill="currentColor" />
        </svg>
        </ng-template>
    `,
})
export class IconWetherCloudComponent {
    @Input() fill: boolean = false;
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
